export default {
	props: {
		percentage: Number,
		toGo:Number,
		isVip:Boolean,
	},
	data(){
		return {
			monthsLeft: 11 - (new Date().getMonth())
		}
	},
	created(){
		this.pe
	}

}


// WEBPACK FOOTER //
// ./src/components/profile/tiers/tiers.js